/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { StateObservable } from "redux-observable";
import { ActionsObservable } from "redux-observable";
import { Observable } from "rxjs";
import { getFullFormVersion } from '../react/components/NewEvalButton';
import { AppAction, AppState } from "../redux";
import { AUTHORIZATION_HEADER } from "./types";

type ActionStream = ActionsObservable<AppAction>;
export function createEpic<T extends AppAction>(
  epic: (
    action$: ActionStream,
    state$: StateObservable<AppState>
  ) => Observable<T>
) {
  return (action$: ActionStream, state$: StateObservable<AppState>) =>
    epic(action$, state$);
}

/**
 * Append token and headers used for debugging to all requests.
 */
export function getCommonHeaders(
  state$: StateObservable<AppState>
): object {

  const token = state$.value.session.dfdmToken;
  const headers: Record<string, string> = {
    [AUTHORIZATION_HEADER]: `Bearer ${
      token ? token.access_token : ''
    }`,
    client: 'eval_training',
    'client-verstion': process.env.REACT_APP_VERSION || ''
  };

  const activeDef = state$.value.forms.activeFormDefinition;

  if (activeDef) {
    const formVersion = getFullFormVersion(activeDef);
    headers['form-version'] = formVersion;
  }

  return headers;
}
